export const OVERWRITE_EXISTING_PACKAGES = 'OVERWRITE_EXISTING_PACKAGES';

export type CustomPackageImportForm = {
  shouldOverwriteExisting: boolean;
};

type OverwriteExistingPackagesAction = {
  type: typeof OVERWRITE_EXISTING_PACKAGES;
  shouldOverwriteExisting: boolean;
};

export const initialState: CustomPackageImportForm = {
  shouldOverwriteExisting: false,
};

export const actionMap = {
  [OVERWRITE_EXISTING_PACKAGES]: (
    state: CustomPackageImportForm,
    { shouldOverwriteExisting }: OverwriteExistingPackagesAction,
  ): CustomPackageImportForm => ({
    ...state,
    shouldOverwriteExisting,
  }),
};
